// extracted by mini-css-extract-plugin
export default {"roomTypesModal":"styles_roomTypesModal__6l8vY","wrapper":"styles_wrapper__Xoqfn","tabWrapper":"styles_tabWrapper__KQ93u","title":"styles_title__CCY5b","tabs":"styles_tabs__AEBPM"};